import { useEffect, useState } from 'react';
import { getPresentation } from '../data/presentations';
import { ensureOkiruTemplate } from '../data/okiruPresentationTemplate';

// Published database content takes precedence over the bundled source deck.
// Keeping the bundled deck as a fallback makes the presentation resilient
// during the migration and when the API is temporarily unavailable.
export default function usePresentation(presentationId) {
  const [presentation, setPresentation] = useState(() => getPresentation(presentationId));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setPresentation(getPresentation(presentationId));
    setLoading(true);
    fetch(`/api/presentations/${encodeURIComponent(presentationId)}/content`)
      .then((response) => response.ok ? response.json() : null)
      .then((json) => {
        if (!cancelled && json?.success) {
          const bundled = getPresentation(presentationId);
          setPresentation({
            manifest: ensureOkiruTemplate({ ...(bundled?.manifest || {}), ...json.data.manifest }),
            slides: json.data.slides,
          });
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [presentationId]);

  return { presentation, loading };
}
